import React,{Suspense} from 'react';
import './App.css';
import Login from './user/login/Login';
import actions from '../constants/DefaultAllowedActions';
import ErrorBoundary from './../shared/components/ErrorBoundary';
import GlobalLoader from './../shared/components/Loader';
import { Switch, Route, Redirect } from 'react-router-dom'
import { lazyWithRetry } from './../shared/services/shared';

const ForgetPassword = lazyWithRetry(() =>  import('./user/forgetPassword/ForgetPassword'));
const ResetPassword = lazyWithRetry(() =>  import('./user/resetPassword/ResetPassword'));
const OTPVerification = lazyWithRetry(() =>  import('./user/verificationOTP/otpVerification'));
const Layout = lazyWithRetry(() =>  import('./Layout'));
const NotFound = lazyWithRetry(() =>  import('./layout/not-found/NotFound'));
class App extends React.Component {

  render(){
    return (
      <Switch>
        <Route render={(props) => (
          <ErrorBoundary {...props } {...this.props} >
            <Renderapp {...props } {...this.props} />
          </ErrorBoundary>
        )} 
      />
      </Switch>
    );
  }
}
class Renderapp extends React.Component{
  
  isAllowed = ()=>{
    
    if(actions.includes(this.props.location.pathname)){
      return true;
    }else if(this.props.location.pathname.search('/analytics/page')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/create/role')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/create/page/')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/tenantconfigurations')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/kbarticle')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/tenantbots')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/botconfig')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/ticketforms/create')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/salesforce/ticketforms')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/templates/update')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/roles')!==-1){
      return true;
    }
    else if(this.props.location.pathname.search('/admin/uploadusers')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/users')!==-1){
      return true;
    }else if(this.props.location.pathname.search('/admin/role/users')!==-1){
      return true;
    }  
    else if(this.props.location.pathname.search('/nudging/campaign/list')!==-1){
      return true;
    }
    return this.props.user?.componentIndentity?.includes(this.props.location?.pathname)
  }

  render(){
    return (
      <Suspense fallback={<GlobalLoader />}>
      <Switch>
        <Route path="/login" render={() => (
            <Login {...this.props}  />
          )} 
        />
        <Route path="/verifyotp" render={() => (
            <OTPVerification  {...this.props} />
          )} 
        /> 
        <Route path="/ForgetPassword" render={() => (
            <ForgetPassword  {...this.props} />
          )} 
        />                

        <Route path="/reset-password/:token" render={(prop) => (
            <ResetPassword {...this.props }  {...prop} />
          )}/>  
        
        { !(this.props.user && this.props.user.isLoggedIn) && <Redirect to='/login' />}
        { !this.isAllowed() && <NotFound /> }
          
        <Route path="/" render={() => (
            <Layout {...this.props } />
          )} />
  
        <Route component={NotFound}/>
      </Switch>
      </Suspense>
    );
  }
  
}

export default App;
